import { Button } from "@shared/ui";

export interface ContentErrorStateProps {
  title: string;
  body: string;
  retryLabel: string;
  onRetry: () => void;
}

export function ContentErrorState({
  title,
  body,
  retryLabel,
  onRetry,
}: ContentErrorStateProps) {
  return (
    <div
      role="alert"
      className="flex flex-col items-center gap-4 rounded-lg border border-destructive/40 bg-background p-6 text-center"
    >
      <h2 className="text-lg font-semibold">{title}</h2>
      <p className="text-sm text-muted-foreground">{body}</p>
      <Button onClick={onRetry} variant="outline" size="sm">
        {retryLabel}
      </Button>
    </div>
  );
}
